import { z } from 'zod'

const env = {
  NEXT_PUBLIC_APP_VERSION: z.string().parse(process.env.NEXT_PUBLIC_APP_VERSION),
}

export { env }
